import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { Store } from '../context/store'
import Login from '../pages/Login'
import Monitoring from '../pages/Monitoring'
import MonitoringCard from '../pages/Monitoring/subpages/MonitoringCard'
import Manage from '../pages/Manage'
// import Herd from '../pages/Manage/subpages/Herd'
import HerdGrp from '../pages/Manage/subpages/HerdGrp'
import HerdGrpCard from '../pages/Manage/subpages/HerdGrpCard'
import MyGroups from '../pages/Manage/subpages/MyGroups'
import MyGroupsCard from '../pages/Manage/subpages/MyGroupsCard'
import Account from '../pages/Manage/subpages/Account'
import Zones from '../pages/Manage/subpages/Zones'
import Zone from '../pages/Manage/subpages/ZoneCard'
import CowCard from '../pages/Manage/subpages/CowCard'
import Scanner from '../pages/Manage/subpages/Scanner'
import ScannerAddTag from '../pages/Manage/subpages/ScannerAddTag'
import Reports from '../pages/Reports'

const PriavteRoute = ({ component: RouteComponent, ...rest }) => {
  const { state } = Store()
  const { user } = state

  return (
    <Route
      {...rest}
      render={routeProps => (user ? <RouteComponent {...routeProps} /> : <Redirect to="/login" />)}
    />
  )
}

const Routes = () => (
  <Router>
    <Switch>
      {/* PATHS */}
      <Route exact path="/login" component={Login} />
      {
        process.env.REACT_APP_VERSION === 'DEMO' &&
        <Route path="/login/:lang" component={Login} />
      }
      <PriavteRoute exact path="/monitoring" component={Monitoring} />
      <PriavteRoute path="/monitoring/:name" component={MonitoringCard} />
      <PriavteRoute exact path="/manage" component={Manage} />
      {/* <PriavteRoute exact path="/manage/herd" component={Herd} /> */}
      <PriavteRoute exact path="/manage/herdgrp" component={HerdGrp} />
      <PriavteRoute exact path="/manage/herdgrp/:name" component={HerdGrpCard} />
      <PriavteRoute exact path="/manage/mygroups" component={MyGroups} />
      <PriavteRoute exact path="/manage/mygroups/:name" component={MyGroupsCard} />
      <PriavteRoute path="/manage/herd/cow/:number" component={CowCard} />
      <PriavteRoute path="/manage/account" component={Account} />
      <PriavteRoute exact path="/manage/zones" component={Zones} />
      <PriavteRoute path="/manage/zones/:name" component={Zone} />
      <PriavteRoute exact path="/manage/scanner" component={Scanner} />
      <PriavteRoute path="/manage/scanner/add-tag" component={ScannerAddTag} />
      <PriavteRoute path="/reports/:name" component={Reports} />
      {/* #PATHS */}
      {/* REDIRECTS */}
      <Redirect from='/' to='/monitoring' />
      {/* #REDIRECTS */}
    </Switch>
  </Router>
)

export default Routes
